import { render, staticRenderFns } from "./HotWindows.vue?vue&type=template&id=12b310de"
import script from "./HotWindows.vue?vue&type=script&lang=ts"
export * from "./HotWindows.vue?vue&type=script&lang=ts"
import style0 from "../styles/hot-windows.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports